import React from "react"
import { Flex, OvalCard, Text } from "@capioweb/ui-components"
import { BlockCommonLayout } from "../../utils/layout"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { PUBLIC_PAGE_API_ENDPOINT } from "../../constants"
import { Link } from "react-router-dom"

export interface CategoryListBlockProps {
	header: StringProperty
	categoryList?: []
}
export interface CategoryListProps {
	title: string
	imageDesktop: string
	pageUrl: string
}

const CapioCategoryListingBlock: React.FC<CategoryListBlockProps> = (props) => {
	return (
		<BlockCommonLayout heading={props.header}>
			<Flex
				w={1}
				flexWrap="wrap"
				justifyContent={{ _: "space-between", m: "flex-start" }}
				alignContent="space-between"
				columnGap={{ m: 3 }}
				rowGap={{ _: 2, m: 3 }}
			>
				{props.categoryList?.map((c: CategoryListProps, i) => {
					return (
						<Flex
							key={i}
							flexGrow={0}
							flexShrink={1}
							w={1}
							flexBasis={{
								_: "calc(100% / 2 - 8px)",
								m: "calc(100% / 3 - 24px)",
								l: "calc(100% / 4 - 18px)",
								xl: "calc(100% / 6 - 20px)",
							}}
						>
							<Link to={c?.pageUrl ?? "#"} style={{ width: "100%" }}>
								<OvalCard
									title={c.title}
									backgroundImage={`${PUBLIC_PAGE_API_ENDPOINT}${c.imageDesktop}?format=webp`}
								></OvalCard>
							</Link>
						</Flex>
					)
				})}
			</Flex>
		</BlockCommonLayout>
	)
}

export { CapioCategoryListingBlock }
